import axios from 'axios';
import apiClient from './apiClient';
import { SAVE_CFG, CFG_BY_USER_ID } from 'clicker-common/src/Config';
import { DEV_MODE } from '../state/Config';

const cfgService = {
  saveCfg: (uid, cfg) => {
    const url = DEV_MODE ? 'saveCfg' : SAVE_CFG + 'saveCfg';
    return apiClient.post(`${url}?uid=${uid}`, { cfg, uid });
  },
  getCfgByUserId: (uid) => {
    const url = DEV_MODE ? 'cfgByUserId' : CFG_BY_USER_ID + 'cfgByUserId';
    return apiClient.get(`${url}?uid=${uid}`);
  },
  getSystemCfgByUid: (uid) => {
    const url = DEV_MODE ? 'cfgByUserId' : CFG_BY_USER_ID + 'cfgByUserId';
    return apiClient.get(`${url}?uid=${uid}`);
  },
  saveSystemCfg: (uid, cfg) => {
    const url = DEV_MODE ? 'saveCfg' : SAVE_CFG + 'saveCfg';
    return apiClient.post(`${url}?uid=${uid}`, { cfg, uid });
  },
  getPublicSystemCfg: () => {
    const url = DEV_MODE ? 'lc_systemCfg.json' : 'https://clicker-system-cfg.web.app/lc_systemCfg.json';
    return axios.get(url);
  },
  getPublicNavCfg: () => {
    const url = 'https://clicker-system-cfg.web.app/lc_nav_cfg.json';
    return axios.get(url);
  },
};

export default cfgService;
